import TabNavigator from './TabNavigator.vue';

export { TabNavigator };
export default TabNavigator;
